var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.baselineStationCollection)?_c('div',{style:({
      top: 0,
      bottom: 0,
      width: '100%',
      height: '100%'
    }),attrs:{"id":_vm.container}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }